import React, { ReactNode } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ReactDOM from "react-dom";
import AppState from "../model/AppState";
import ListaModel from "../model/ListaModel";
import ProdutoModel from "../model/ProdutoModel";
import NavegadorUtil from "../util/NavegadorUtil";

type ModalListasProps = {
  observacao?: string;
  children?: ReactNode;
  visivel: boolean;
  produto: ProdutoModel;
  toggleModalLista: any;
  parent: any;
};

type ModalListasState = {
  showNovaListaForm: boolean;
  listas: ListaModel[];
};

class ModalListas extends React.Component<ModalListasProps, any> {
  constructor(props: ModalListasProps) {
    super(props);
    this.showNovaListaForm = this.showNovaListaForm.bind(this);
    this.saveLista = this.saveLista.bind(this);
    this.saveListas = this.saveListas.bind(this);

    this.state = {
      showNovaListaForm: false,
      listas: [],
    };
  }

  componentDidMount(): any {}

  componentDidUpdate(prevprops: ModalListasProps, prevstate: any): any {
    if (!prevprops.visivel && this.props.visivel) {
      AppState.getListas().then((listas: ListaModel[]) => {
        this.setState({
          listas,
        });
      });
    }
  }

  async saveLista(): Promise<void> {
    const { parent } = this.props;
    const nomeLista: any = ReactDOM.findDOMNode(this.refs.nomeLista);
    AppState.addLista(nomeLista.value).then(() => {
      this.showNovaListaForm();
      AppState.getListas().then((listas: ListaModel[]) => {
        this.setState({
          listas,
        });
      });
    }).catch((ex) => {
      NavegadorUtil.alerta(parent, ex.message);
      return;
    });
  }

  showNovaListaForm(): void {
    this.setState({ showNovaListaForm: !this.state.showNovaListaForm });
  }

  async saveListas(): Promise<void> {
    const nomeLista: any = ReactDOM.findDOMNode(this.refs.nomeLista);
    const { produto, observacao, parent } = this.props;
    let adicionado: boolean | null = null;

    if (nomeLista && nomeLista.value.length > 0) {
      AppState.addLista(nomeLista.value).then(
        async (lista: ListaModel | null) => {
          if (lista) {
            adicionado = await AppState.addListaItem(
              lista.listaId,
              produto,
              observacao
            );
            if (adicionado) {
              NavegadorUtil.alerta(parent, "Lista criada e item adicionado com sucesso");
            } else {
              NavegadorUtil.alerta(parent, "Falha ao adicionar item à nova lista");
            }
          }
        }
      ).catch((ex) => {
        NavegadorUtil.alerta(parent, ex.message);
        return;
      });
    } else {
      const listas: any = ReactDOM.findDOMNode(this.refs.listasUL);
      const items: any = listas.getElementsByClassName("item");
  
      for (const item of items) {
        if (item.checked) {
          adicionado = await AppState.addListaItem(
            item.value,
            produto,
            observacao
          );
        }
      }
  
      if (adicionado) {
        NavegadorUtil.alerta(parent, "Adicionado com sucesso à(s) lista(s)");
      } else {
        NavegadorUtil.alerta(
          parent,
          "Item já está na(s) lista(s) selecionada(s)"
        );
      }
    }

    this.props.toggleModalLista();
  }

  render(): any {
    const { listas } = this.state;

    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal" id="lists-modal">
            <p className="title">A quais listas deseja adicionar?</p>
            <ul ref="listasUL">
              {listas &&
                listas.map((lista: ListaModel) => (
                  <li key={lista.listaId}>
                    <input
                      type="checkbox"
                      value={lista.listaId}
                      id={lista.listaId}
                      className="item"
                    />
                    <label htmlFor={lista.listaId}>{lista.nome}</label>
                  </li>
                ))}
            </ul>
            {!this.state.showNovaListaForm && (
              <button className="add-new-li" onClick={this.showNovaListaForm}>
                &nbsp;&nbsp;+ &nbsp;Nova lista
              </button>
            )}
            {this.state.showNovaListaForm && (
              <div className="add-new-li-form">
                <input
                  type="text"
                  className="txt"
                  placeholder="Informe o nome da lista"
                  ref="nomeLista"
                />
                <button onClick={this.saveLista}>
                  <img
                    src={NavegadorUtil.getUrl(
                      "/assets/images/icons/plus-circle.svg"
                    )}
                    alt="salvar"
                  />
                </button>
              </div>
            )}
            <div className="menu">
              <button onClick={this.props.toggleModalLista}>Cancelar</button>
              <button onClick={this.saveListas}>Salvar</button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalListas;
